var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "pdp-bottom" }, [
    _c(
      "div",
      { staticClass: "pdp__bottom-mobile" },
      [
        _vm.features && _vm.features.length > 0
          ? _c(
              "accordion",
              {
                attrs: {
                  heading: "Features",
                  activeIcon: "chevron-down",
                  inactiveIcon: "chevron-up",
                  selected: ""
                }
              },
              [
                _c("div", { staticClass: "block__title" }, [
                  _vm._v("Features")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "feature__block-feature-list",
                    class: [_vm.features.length == 1 ? "full-width" : ""]
                  },
                  _vm._l(_vm.features, function(feature, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "feature__block-feature-item"
                      },
                      [_vm._v("\n          " + _vm._s(feature) + "\n        ")]
                    )
                  }),
                  0
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.includes && _vm.includes.length > 0
          ? _c(
              "accordion",
              {
                attrs: {
                  heading: "Includes",
                  activeIcon: "chevron-down",
                  inactiveIcon: "chevron-up"
                }
              },
              [
                _c("div", { staticClass: "block__title" }, [
                  _vm._v("Includes")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "includes__block-includes-container" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "includes_block-includes-intro-content",
                        class: [_vm.includes.length == 1 ? "full-width" : ""]
                      },
                      _vm._l(_vm.includes, function(intro, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "includes_block-includes-intro-item"
                          },
                          [
                            _vm._v(
                              "\n            " + _vm._s(intro) + "\n          "
                            )
                          ]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _vm.includes.Image
                      ? _c(
                          "div",
                          { staticClass: "includes_block-includes-image" },
                          [
                            _c("img", {
                              attrs: {
                                src: _vm.includes.Image,
                                alt: "includes.Introduction"
                              }
                            })
                          ]
                        )
                      : _vm._e()
                  ]
                )
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.specs && _vm.specs.length > 0
          ? _c(
              "accordion",
              {
                attrs: {
                  heading: "Specifications",
                  activeIcon: "chevron-down",
                  inactiveIcon: "chevron-up"
                }
              },
              [
                _c("div", { staticClass: "block__title" }, [
                  _vm._v("Specifications")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "specs__block-spec-list",
                    style: { maxHeight: _vm.showAllSpec ? "484px" : "none" }
                  },
                  [
                    _vm._l(_vm.specs, function(spec, index) {
                      return [
                        _vm.showSpecLabel(spec.name)
                          ? _c(
                              "div",
                              {
                                key: index,
                                staticClass: "specs__block-spec-item"
                              },
                              [
                                _c("div", {
                                  staticClass: "specs__block-spec-key",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.getSpecLabel(spec.name)
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "specs__block-spec-value" },
                                  [_vm._v(" " + _vm._s(spec.value) + " ")]
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                Object.keys(_vm.specs).length > 8
                  ? [
                      _c("div", { staticClass: "specs__block-gradient-layer" }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "specs__block-btn-view-all-specs",
                          on: {
                            click: function($event) {
                              _vm.showAllSpec = !_vm.showAllSpec
                            }
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "specs__block-plus-label" },
                            [_vm._v(_vm._s(_vm.showAllSpec ? "+" : "-"))]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "specs__block-btn-text" }, [
                            _vm._v(
                              _vm._s(
                                _vm.showAllSpec
                                  ? "View All Specifications"
                                  : "Hide Specifications"
                              )
                            )
                          ])
                        ]
                      )
                    ]
                  : _vm._e()
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.manuals && Array.isArray(_vm.manuals.filename)
          ? _c(
              "accordion",
              {
                staticClass: "manual__block",
                attrs: {
                  heading: "Additional Product Information",
                  activeIcon: "chevron-down",
                  inactiveIcon: "chevron-up"
                }
              },
              [
                _c("div", { staticClass: "block__title" }, [
                  _vm._v("Additional Product Information")
                ]),
                _vm._v(" "),
                _vm._l(_vm.manuals.source, function(manual, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "manual__block-manual-item test1"
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "manual__block-manual-item-wrapper" },
                        [
                          _c("Icon", { attrs: { name: "file", size: "16px" } }),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "manual_item-file-name",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.getManualsLabel(manual.original)
                              )
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "download-container",
                          attrs: {
                            href: _vm.getManualsLink(manual.original),
                            target: "_blank"
                          }
                        },
                        [
                          _c(
                            "span",
                            { staticClass: "manual_item-download-link" },
                            [_vm._v("Download")]
                          ),
                          _vm._v(" "),
                          _c("Icon", {
                            attrs: { name: "download", size: "24px" }
                          })
                        ],
                        1
                      )
                    ]
                  )
                })
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.manuals && Array.isArray(_vm.manuals.filename) == false
          ? _c(
              "accordion",
              {
                staticClass: "manual__block",
                attrs: {
                  heading: "Additional Product Information",
                  activeIcon: "chevron-down",
                  inactiveIcon: "chevron-up"
                }
              },
              [
                _c("div", { staticClass: "block__title" }, [
                  _vm._v("Additional Product Information")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "manual__block-manual-item test2" }, [
                  _c(
                    "div",
                    { staticClass: "manual__block-manual-item-wrapper" },
                    [
                      _c("Icon", { attrs: { name: "file", size: "16px" } }),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "manual_item-file-name",
                        domProps: { innerHTML: _vm._s(_vm.manuals.filename) }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "download-container",
                      attrs: {
                        href: _vm.getManualsLink(_vm.manuals.source.original),
                        target: "_blank"
                      }
                    },
                    [
                      _c("span", { staticClass: "manual_item-download-link" }, [
                        _vm._v("Download")
                      ]),
                      _vm._v(" "),
                      _c("Icon", { attrs: { name: "download", size: "24px" } })
                    ],
                    1
                  )
                ])
              ]
            )
          : _vm._e()
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "pdp__bottom-desktop" }, [
      _vm.features && _vm.features.length > 0
        ? _c(
            "section",
            {
              staticClass: "feature__block",
              attrs: { id: "section-features" }
            },
            [
              _c("div", { staticClass: "block__title" }, [_vm._v("Features")]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "feature__block-feature-list",
                  class: [_vm.features.length == 1 ? "full-width" : ""]
                },
                _vm._l(_vm.features, function(feature, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "feature__block-feature-item" },
                    [_vm._v("\n          " + _vm._s(feature) + "\n        ")]
                  )
                }),
                0
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.includes && _vm.includes.length > 0
        ? _c(
            "section",
            {
              staticClass: "includes__block",
              attrs: { id: "section-includes" }
            },
            [
              _c("div", { staticClass: "block__title" }, [_vm._v("Includes")]),
              _vm._v(" "),
              _c("div", { staticClass: "includes__block-includes-container" }, [
                _c(
                  "div",
                  {
                    staticClass: "includes_block-includes-intro-content",
                    class: [_vm.includes.length == 1 ? "full-width" : ""]
                  },
                  _vm._l(_vm.includes, function(intro, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "includes_block-includes-intro-item"
                      },
                      [
                        _vm._v(
                          "\n            " + _vm._s(intro) + "\n          "
                        )
                      ]
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _vm.includes.Image
                  ? _c(
                      "div",
                      { staticClass: "includes_block-includes-image" },
                      [
                        _c("img", {
                          attrs: {
                            src: _vm.includes.Image,
                            alt: "includes.Introduction"
                          }
                        })
                      ]
                    )
                  : _vm._e()
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.specs && _vm.specs.length > 0
        ? _c(
            "section",
            {
              staticClass: "specs__block",
              class: [
                { "specs__block-collapse": !_vm.showAllSpec },
                {
                  "specs__block-no__expandable":
                    Object.keys(_vm.specs).length < 9
                }
              ],
              attrs: { id: "section-specs" }
            },
            [
              _c("div", { staticClass: "block__title" }, [
                _vm._v("Specifications")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "specs__block-spec-list" },
                [
                  _vm._l(_vm.specs, function(spec, index) {
                    return [
                      _vm.showSpecLabel(spec.name)
                        ? _c(
                            "div",
                            {
                              key: `spec-${index}`,
                              staticClass: "specs__block-spec-item"
                            },
                            [
                              _c("div", {
                                staticClass: "specs__block-spec-key",
                                domProps: {
                                  innerHTML: _vm._s(_vm.getSpecLabel(spec.name))
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "specs__block-spec-value" },
                                [_vm._v(" " + _vm._s(spec.value) + " ")]
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  })
                ],
                2
              ),
              _vm._v(" "),
              Object.keys(_vm.specs).length > 8
                ? [
                    _c("div", { staticClass: "specs__block-gradient-layer" }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "specs__block-btn-view-all-specs",
                        on: {
                          click: function($event) {
                            _vm.showAllSpec = !_vm.showAllSpec
                          }
                        }
                      },
                      [
                        _c("span", { staticClass: "specs__block-plus-label" }, [
                          _vm._v(_vm._s(_vm.showAllSpec ? "+" : "-"))
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "specs__block-btn-text" }, [
                          _vm._v(
                            _vm._s(
                              _vm.showAllSpec
                                ? "View All Specifications"
                                : "Hide Specifications"
                            )
                          )
                        ])
                      ]
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.manuals && Array.isArray(_vm.manuals.filename)
        ? _c(
            "section",
            { staticClass: "manual__block", attrs: { id: "section-manuals" } },
            [
              _c("div", { staticClass: "block__title" }, [
                _vm._v("Additional Product Information")
              ]),
              _vm._v(" "),
              _vm._l(_vm.manuals.source, function(manual, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "manual__block-manual-item test3"
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "manual__block-manual-item-wrapper" },
                      [
                        _c("Icon", { attrs: { name: "file", size: "20px" } }),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "manual_item-file-name",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getManualsLabel(manual.original)
                            )
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "download-container",
                        attrs: {
                          href: _vm.getManualsLink(manual.original),
                          target: "_blank"
                        }
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "manual_item-download-link" },
                          [_vm._v("Download")]
                        ),
                        _vm._v(" "),
                        _c("Icon", {
                          attrs: { name: "download", size: "24px" }
                        })
                      ],
                      1
                    )
                  ]
                )
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.manuals && Array.isArray(_vm.manuals.filename) == false
        ? _c(
            "section",
            { staticClass: "manual__block", attrs: { id: "section-manuals" } },
            [
              _c("div", { staticClass: "block__title" }, [
                _vm._v("Additional Product Information")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "manual__block-manual-item test4" }, [
                _c(
                  "div",
                  { staticClass: "manual__block-manual-item-wrapper" },
                  [
                    _c("Icon", { attrs: { name: "file", size: "20px" } }),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "manual_item-file-name",
                      domProps: { innerHTML: _vm._s(_vm.manuals.filename) }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "download-container",
                    attrs: {
                      href: _vm.getManualsLink(_vm.manuals.source.original),
                      target: "_blank"
                    }
                  },
                  [
                    _c("span", { staticClass: "manual_item-download-link" }, [
                      _vm._v("Download")
                    ]),
                    _vm._v(" "),
                    _c("Icon", { attrs: { name: "download", size: "24px" } })
                  ],
                  1
                )
              ])
            ]
          )
        : _vm._e()
    ]),
    _vm._v(" "),
    _vm.isChildProductsLoaded && _vm.childProducts.length > 1
      ? _c(
          "section",
          {
            staticClass: "product-line__block",
            attrs: { id: "section-product-line" }
          },
          [
            _c("div", { staticClass: "block__title" }, [
              _vm._v("Product Line")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "product-line__block-child__products" },
              [
                _vm.childProducts.length > 1
                  ? _c(
                      "button",
                      {
                        staticClass: "product-line__prev-button",
                        attrs: { "aria-label": "Previous Product" },
                        on: { click: _vm.childProductPrevious }
                      },
                      [
                        _c("Icon", {
                          staticClass: "product-line__button",
                          attrs: { name: "chevron-left", size: "44px" }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "flickity",
                  {
                    ref: "flickity",
                    staticClass: "product-line__block-child__products-flickity",
                    attrs: { options: _vm.flickityOptions },
                    on: { sendToPLModal: _vm.openSliderModal }
                  },
                  [
                    _vm._l(_vm.childProducts, function(product, index) {
                      return [
                        index < 20
                          ? _c(
                              "div",
                              {
                                key: index,
                                staticClass:
                                  "carousel-cell product-line__block-child_products-carousel-cell"
                              },
                              [
                                _c("ProductCard", {
                                  attrs: {
                                    inSlider: true,
                                    placeholder: _vm.placeholder,
                                    data: JSON.stringify({ product }),
                                    quickviewData: JSON.stringify({ product })
                                  },
                                  on: { sliderQuickview: _vm.sendDataToPLModal }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.childProducts.length > 1
                  ? _c(
                      "button",
                      {
                        staticClass: "product-line__next-button",
                        attrs: { "aria-label": "Next Product" },
                        on: { click: _vm.childProductNext }
                      },
                      [
                        _c("Icon", {
                          staticClass: "product-line__button",
                          attrs: { name: "chevron-right", size: "44px" }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "Modal",
              {
                ref: "sliderQuickview",
                staticClass: "quickview-modal",
                attrs: { useTransition: false }
              },
              [
                _c(
                  "template",
                  { slot: "content" },
                  [
                    _c("ProductTop", {
                      staticClass: "pdp-top--quickview",
                      attrs: {
                        data: _vm.sliderQuickviewData,
                        isQuickview: true
                      },
                      on: { addToCart: _vm.closeModal }
                    })
                  ],
                  1
                )
              ],
              2
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }